"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8719],{

/***/ 8719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ asg_brand_card_list_AsgBrandCardList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/base/image/index.tsx + 1 modules
var base_image = __webpack_require__(5244);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 6 modules
var gridview = __webpack_require__(8117);
// EXTERNAL MODULE: ./components/base/icon/Icon.tsx
var Icon = __webpack_require__(6653);
;// CONCATENATED MODULE: ./components/widgets/asg-brand-card-list/AsgBrandCardList.tsx





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AsgBrandCardList = function(props) {
    var ref;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
        className: "brand-card-list",
        gutter: "lg",
        children: (ref = props.data) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(gridview/* Column */.sg, {
                xs: {
                    size: 12
                },
                sm: {
                    size: 6
                },
                lg: {
                    size: 4
                },
                xl: {
                    size: 4
                },
                className: 'brand-card-item',
                children: [
                    item.links && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "link-wrapper",
                        children: item.links.map(function(item2, index2) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                href: item2.href,
                                rel: "noreferrer",
                                children: item2.children
                            }, index2);
                        })
                    }),
                    item.links && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: item.links.map(function(item2, index2) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
                                target: "_blank",
                                href: item2.href,
                                rel: "noreferrer",
                                className: "pdf-link",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(base_image["default"], _objectSpread({
                                        alt: item.title
                                    }, item.image, {
                                        style: {
                                            borderRadius: '30px'
                                        }
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        name: "icon-file-download"
                                    })
                                ]
                            }, index2);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "title",
                        style: {
                            marginBottom: 0
                        },
                        children: item.firmName
                    }),
                    item.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "title bottom",
                        children: item.title
                    }) : null
                ]
            }, item.title);
        })
    }));
};
/* harmony default export */ var asg_brand_card_list_AsgBrandCardList = (AsgBrandCardList);

;// CONCATENATED MODULE: ./components/widgets/asg-brand-card-list/index.tsx



/***/ })

}]);